import { AUDIT_BASE_URL } from '../../utils/ApiUrls';

class FollowupAttachmentService {
    /**
     * Download a followup attachment
     * @param {string} accessToken - JWT access token
     * @param {number} attachmentId - Attachment ID
     * @param {string} fileName - File name for download
     */
    async downloadAttachment(accessToken, attachmentId, fileName) {
        try {
            const response = await fetch(
                `${AUDIT_BASE_URL}/followup-attachments/${attachmentId}/download/`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                return {
                    success: false,
                    status: response.status,
                    error: errorData.detail || 'Failed to download attachment'
                };
            }

            // Get the blob from response
            const blob = await response.blob();
            
            // Create a download link and trigger download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return {
                success: true,
                status: response.status
            };
        } catch (error) {
            return {
                success: false,
                status: 0,
                error: error.message || 'Network error occurred'
            };
        }
    }
}

const followupAttachmentService = new FollowupAttachmentService();
export default followupAttachmentService;
